import { render, staticRenderFns } from "./ListRezultataSingle.vue?vue&type=template&id=07c3f82a&scoped=true&"
import script from "./ListRezultataSingle.vue?vue&type=script&lang=js&"
export * from "./ListRezultataSingle.vue?vue&type=script&lang=js&"
import style0 from "./ListRezultataSingle.vue?vue&type=style&index=0&id=07c3f82a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c3f82a",
  null
  
)

export default component.exports